import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import Form from 'src/views/admin/TimeSensitiveItemTypes/Form';

const propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  fetchTimeSensitiveItemType: PropTypes.func.isRequired,
};

const EditForm = (props) => {
  const {
    match: {params},
    fetchTimeSensitiveItemType,
  } = props;
  const [type, setType] = useState(null);

  useEffect(() => {
    fetchTimeSensitiveItemType(params.id).then((response) => {
      setType(response);
    });
  }, []);

  if (!type) {
    return null;
  }

  return <Form type={type} />;
};

EditForm.propTypes = propTypes;

export default EditForm;
